export default "__VITE_PUBLIC_ASSET__6d1f4dac__"